<template>
  <div
    class="sidenav-wrap hidden sm:hidden md:hidden lg:block"
  >
    <div class="sidenav" id="sidenav">
      <div class="sidenav-header">
        <h1>
            <router-link :to="{ name: 'loanSummary'}">
              <img
                class="sidenav-logo"
                :src="'/img/car-brands/' + brandLogo"
                alt="Logo"
                width="119px"
                height="20px"
              />
            </router-link>
        </h1>
      </div>
      <div class="sidenav-content">
        <ul class="sidenav-nav">
          <li>
            <router-link class="truncate" :to="{ name: 'loanSummary'}" active-class="active" :exact="false">
              <i class="vlicon icon-home"></i>Thông tin khoản vay
            </router-link>
          </li>
          <li>
            <router-link class="truncate" :to="{ name: 'paymentIntroduction'}" active-class="active" :exact="false">
              <i class="vlicon icon-credit-card"></i>Thanh toán trực tuyến
            </router-link>
          </li>
          <li>
            <router-link class="truncate" :to="{ name: 'earlyPaymentList'}" active-class="active" :exact="false">
              <i class="vlicon icon-calculator"></i>Tính toán trả nợ sớm
            </router-link>
          </li>
          <li>
            <router-link class="truncate" :to="{ name: 'support'}" active-class="active" :exact="false">
              <i class="vlicon icon-edit"></i>Yêu cầu hỗ trợ
            </router-link>
          </li>
          <li>
          <router-link class="truncate" :to="{ name: 'profile'}" active-class="active">
              <i class="vlicon icon-user-o"></i>Thông tin khách hàng
          </router-link>
          </li>
          <li>
            <a class="truncate" href="#" @click="logout">
              <i class="vlicon icon-logout"></i>Đăng xuất
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from '../services/auth.service'

export default {
  name: 'Sidebar',
  data () {
    return {
      currentYear: new Date().getFullYear(),
      brandLogo: 'toyota.png'
    }
  },
  methods: {
    logout () {
      AuthService.makeLogout()
    }
  },
  created () {
    if (this.$store.state.user.currentUser.IsHinoAccount === true) {
      this.brandLogo = 'hino.png'
    }
    const self = this
    this.$bus.$on('changeBrandLogo', function (b) {
      if (typeof b !== 'undefined' && b) {
        self.brandLogo = b
      } else {
        if (this.$store.state.user.currentUser.IsHinoAccount === true) {
          self.brandLogo = 'hino.png'
        } else {
          self.brandLogo = 'toyota.png'
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
  background-color: #ccc;
  padding: 40px 0;
  width: 100%;
  margin-top: auto;
}
</style>
